import type { Page } from '../../types';
import { getColumns, getKeys, getRows } from '../../../components/form/CoreNpsConsolidatedInput';

const candidateExperience: Page[] = [
  {
    pageType: 'question',
    title: 'Candidate Experience',
    name: 'nps-candidate',
    questions: [
      {
        questionType: 'CoreNpsConsolidatedInput',
        title: 'Net Promoter Score',
        name: 'nps-candidate',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments and observations',
        name: 'nps-candidate-comments',
        hint: 'Please outline any factors that may explain quarter-on-quarter change or influence these reported figures.',
        rules: {
          required: false,
        },
      },
    ],
  },
];

export default candidateExperience;
